import React from 'react';
import { SectionTitle } from 'ui/SectionTitle';
import { RecordField } from './RecordField';
import { RecordsGrid } from './style';

function RecordFields({ record, fields }) {
  return (
    <RecordsGrid>
      {fields.map(({ label, key, computedValue }) => {
        if (key === 'sectionTitle') {
          return (
            <SectionTitle offset={12} style={{ marginBottom: 0 }}>
              {label}
            </SectionTitle>
          );
        }

        return (
          <RecordField
            key={key}
            label={label}
            value={computedValue || record[key]}
          />
        );
      })}
    </RecordsGrid>
  );
}

export { RecordFields };
